"use strict";

/**
 * @classdesc
 * ALKIS Vektordaten-Export-Panel
 *
 * @class
 * @extends gc.gis.widget.GCPanel
 * @memberof gc.gis.module.GCAlkisExport
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.module.GCAlkisExport} options.module Modul-Instanz
 */
gc.gis.module.GCAlkisExport.Panel = function(options)
{
    var self = this;

    gc.gis.assert.isSet(options);
    gc.gis.assert.isInstance(options.module, gc.gis.module.GCAlkisExport);

	/**
	 * @type {gc.gis.module.GCAlkisExport}
	 * @private
	 */
	this._module = options.module;

	/**
	 * @type {gc.gis.util.GCForm}
	 * @private
	 */
	this._form = null;

	/**
	 * Aktueller Zustand (aktiv, deaktiv)
	 * @type {boolean}
	 * @private
	 */
	this._isEnabled = false;

    // Aktionsleiste
	this._export_button = new gc.gis.widget.GCItem({
		label: 'Daten exportieren',
		className: 'btn btn-success',
		tooltip: 'ALKIS - Vektordaten exportieren (bis 1:' + this._module.maxScale.toLocaleString() + ')',
		//icon: 'glyphicon glyphicon-save',
		click: function(evt)
        {
	        try
	        {
	        	if (self._isEnabled)
		        {
			        self._form.submit();
		        }
	        }
	        catch(err)
	        {
		        gc.gis.iface.log.error(self, err);
	        }
		}
	});

	var options_widget = {
		actionbar: new gc.gis.widget.GCMenu({
			containerClassName: 'gc-alkisexport-actionbar',
			items: [
				this._export_button
			]
		})
	};

    gc.gis.widget.GCPanel.call(this, options_widget);

	// Inhalt erzeugen
    this.element = this._render();
    this._initContent();
    this._disable();

    // Listener registrieren
	this._module.map.on(gc.gis.map.GCMapEvent.SCALE_CHANGED, this, function(evt) {
		self._doScaleChange(evt.newValue);
	});
};
gc.gis.module.GCAlkisExport.Panel.prototype = Object.create(gc.gis.widget.GCPanel.prototype);

/**
 * Initialisiert den Panel-Inhalt
 *
 * @protected
 * @method
 */
gc.gis.module.GCAlkisExport.Panel.prototype._initContent = function()
{
	var self = this;

	var form_config = {
		className: 'gc-alkisexport-form',
		controls: [
			{
				label: 'Exportformat',
				name: 'format',
				type: 'select',
				options: this._module.getSupportedFormats()
			},
			{
				type: 'checkbox',
				label: 'nur vollständig sichtbare Objekte exportieren',
				name: 'within',
				default: false
			}
		],
		submit: function (form, params) {
			form.setLoading(true, '');
			self._module.exportData(params.format, gc.gis.GCUtil.parseBool(params.within, false));
			form.setLoading(false);
		}
	};

	this._form = gc.gis.util.GCFormRenderer.renderForm(form_config);
	this.element_content.append(this._form.getElement());
};

/**
 * Ereignisbehandlungsroutine, die beim Ändern des Maßstabs aufgerufen wird.
 *
 * @param {number} scale
 * @private
 */
gc.gis.module.GCAlkisExport.Panel.prototype._doScaleChange = function(scale)
{
	var enable = scale <= this._module.maxScale;

	if (this._isEnabled !== enable)
	{
		enable ? this._enable() : this._disable();
	}
};

/**
 * Aktiviert den Export.
 *
 * @private
 */
gc.gis.module.GCAlkisExport.Panel.prototype._enable = function()
{
	this._form.enable();
	this._export_button.setEnabled(true);
	this._isEnabled = true;
};

/**
 * Deaktiviert den Export.
 *
 * @private
 */
gc.gis.module.GCAlkisExport.Panel.prototype._disable = function()
{
	this._form.disable();
	this._export_button.setEnabled(false);
	this._isEnabled = false;
};